import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  // Handle both 'pl' and 'pl-PL' formats
  const currentLang = i18n.language?.split('-')[0] || 'en';

  const switchLanguage = (lang) => {
    // Don't do anything if same language
    if (lang === currentLang) return;
    
    // Change language
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <div className="flex items-center gap-1 px-2 py-1 rounded-lg bg-white/20 backdrop-blur-md">
      <Globe className="w-3.5 h-3.5 text-navy/60" />
      <motion.button
        onClick={() => switchLanguage('pl')}
        data-testid="language-switch-pl"
        className={`px-2 py-0.5 text-xs font-medium rounded transition-colors ${
          currentLang === 'pl'
            ? 'bg-navy text-white'
            : 'text-navy/60 hover:text-navy'
        }`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        PL
      </motion.button>
      <motion.button
        onClick={() => switchLanguage('en')}
        data-testid="language-switch-en"
        className={`px-2 py-0.5 text-xs font-medium rounded transition-colors ${
          currentLang === 'en'
            ? 'bg-navy text-white'
            : 'text-navy/60 hover:text-navy'
        }`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        EN
      </motion.button>
    </div>
  );
};

export default LanguageSwitcher;
